import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onBeforeUnmount, onBeforeMount } from 'vue';
import {initAppStore} from "@/store/init";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const setViewportHeight = (): void => {
  const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

onMounted(() => {
  setViewportHeight();
  window.addEventListener('resize', setViewportHeight);
});
onBeforeMount(async () => {
  await initAppStore()
})

onBeforeUnmount( () => {
  window.removeEventListener('resize', setViewportHeight);

});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})